module.exports = __webpack_public_path__ + "static/img/907405d00d33bcffc56e26243ac6cebd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/index_img1.png
// module id = LL6M
// module chunks = 1